import { AxiosRequestConfig } from 'axios';
import qs from 'qs';

/**
 * Factory for creating axios request config.
 * 
 * Future: ugprade axios library and then remove paramsSerializer. It is inbuilt in higher versions
 * 
 * Usage:
 * - AxiosConfigFactory.createConfig({ foo: ['bar', 'baz'] });
 */
export const AxiosConfigFactory = {
	createRequestConfig(queryParams?: Record<string, any>): AxiosRequestConfig {
		return {
			params: queryParams,
			// For serialising a query param that is an array of strings
			paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
		};
	}
};